export default __webpack_public_path__ + "static/media/edit_human.857dc944.svg";